import { HttpClient } from "@/api/services/http";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// types.ts or in same file

export type Notification = {
  id: string;
  type: string;
  payload: {
    title: string;
    routingType: string;
  };
  entity_id: string;
  created_at?: string;
  is_read: boolean;
};

export type NotificationCounts = {
  unassigned: number;
  inbox: number;
  mentions: number;
};

export type NotificationState = {
  notifications: {
    counts: NotificationCounts;
    inbox: Notification[];
    unassigned: Notification[];
    mentions: Notification[];
  };
};

// initialState.ts

const initialState: NotificationState = {
  notifications: {
    counts: {
      unassigned: 0,
      inbox: 0,
      mentions: 0,
    },
    inbox: [],
    unassigned: [],
    mentions: [],
  },
};

export const getUserNotifications = createAsyncThunk(
  "auth/getUserNotifications",
  async (_, { rejectWithValue, getState }) => {
    try {
      // Wait for auth to be loaded before proceeding
      const state = getState() as any;
      const user = state.auth.user;

      // If auth not loaded yet, return empty state
      if (!user || !user.role) {
        console.log("Auth not loaded yet, skipping notifications API call");
        return {
          counts: { unassigned: 0, inbox: 0, mentions: 0 },
          inbox: [],
          unassigned: [],
          mentions: [],
        };
      }

      // If user is agent, don't make API call
      if (user.role === 'WORKSPACE_AGENT') {
        console.log("Skipping notifications API call for agent account");
        return {
          counts: { unassigned: 0, inbox: 0, mentions: 0 },
          inbox: [],
          unassigned: [],
          mentions: [],
        };
      }

      const response = await HttpClient.apiClient.get("/profile/notifications");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch user notifications");
    }
  }
);
const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setUnassignedCount: (state) => {
      state.notifications.counts.unassigned += 1;
    },
    setInboxCount: (state) => {
      state.notifications.counts.inbox += 1;
    },
    setUnassignedData: (state, action) => {
      if (!state.notifications.unassigned.find((notification) => notification.id === action.payload.id)) {
        state.notifications.unassigned.push(action.payload);
      }
    },
    setInboxData: (state, action) => {
      if (!state.notifications.inbox.find((notification) => notification.id === action.payload.id)) {
        state.notifications.inbox.push(action.payload);
      }
    },
    setMentionsCount: (state) => {
      state.notifications.counts.mentions += 1;
    },
    setMentionsData: (state, action) => {
      if (!state.notifications.mentions.find((notification) => notification.id === action.payload.id)) {
        state.notifications.mentions.push(action.payload);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserNotifications.fulfilled, (state, action) => {
      state.notifications = action.payload;
    });
  },
});


export const { setUnassignedCount, setInboxCount, setMentionsCount, setUnassignedData, setInboxData, setMentionsData } = notificationSlice.actions;
export default notificationSlice.reducer;